import React, {SyntheticEvent} from 'react';
import {injectIntl, IntlShape} from 'react-intl';
import {ButtonPrimary, ButtonLink} from '@homeaway/react-buttons';
import './DropdownPanel.less';

import type {ReactNode} from 'react';

type Props = {
    applyLabel?: string;
    children?: ReactNode;
    clearLabel?: string;
    clearVisible?: boolean;
    intl: IntlShape;
    submitDisabled?: boolean;
    onApply?: (event: SyntheticEvent<HTMLInputElement>) => void;
    onClear?: () => void;
    showButtons?: boolean;
};

function DropdownPanel({
    children,
    clearLabel = 'formModalResetLabel',
    applyLabel = 'formModalApplyLabel',
    intl: {formatMessage},
    onApply,
    onClear,
    submitDisabled,
    clearVisible,
    showButtons,
}: Props) {
    return (
        <div className="DropdownPanel">
            <div className="DropdownPanel__content">
                <div className="DropdownPanel__children">{children}</div>
                {showButtons && (
                    <div className="DropdownPanel__buttons">
                        {clearVisible && (
                            <ButtonLink
                                className="DropdownPanel-clear-button"
                                key="DropdownPanel-clear-button"
                                data-wdio="DropdownPanel-clear-button"
                                label={formatMessage({
                                    id: clearLabel,
                                    defaultMessage: 'Clear',
                                    description:
                                        'label to identify the secondary button in the panel',
                                })}
                                onClick={onClear}
                                size={'xs'}
                            />
                        )}
                        <ButtonPrimary
                            className="DropdownPanel__apply-button"
                            key="DropdownPanel-apply-button"
                            data-wdio="DropdownPanel-apply-button"
                            disabled={submitDisabled}
                            label={formatMessage({
                                id: applyLabel,
                                defaultMessage: 'Apply',
                                description:
                                    'label to identify the secondary button in the panel',
                            })}
                            onClick={onApply}
                            size={'xs'}
                        />
                    </div>
                )}
            </div>
        </div>
    );
}

export default injectIntl(DropdownPanel);
